import React from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty, map } from 'lodash'
import {
  List,
  ListItemActions,
  ListItemAction,
  ListItem,
  Link,
  Button,
  Icon,
  Alert
} from 'camino-react'

import TicketSelector from './TicketSelector'

import { cloudhelpGet } from 'Utilities/CloudHelp'
import IncidentReport from '../IncidentReport'

class AssociatedTicketContent extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      ticketID: null,
      successMessage: null
    }

    this.getUnassignedTickets = this.getUnassignedTickets.bind(this)
  }

  componentDidMount () {
    this.getUnassignedTickets()
  }

  componentWillReceiveProps (newProps) {
    const { tickets } = this.props

    if (newProps.tickets !== tickets) {
      this.getUnassignedTickets()
    }
  }

  getUnassignedTickets () {
    const { paths } = this.props
    const { apiProblemsUnassignedTicketsPath } = paths

    cloudhelpGet(apiProblemsUnassignedTicketsPath)
      .then((response) => {
        const tickets = response.data

        const unassignedTickets =
          Object.assign({}, ..._.map(_.orderBy(tickets, 'id'), ({ id, title, clientName }) => ({ [id]: `${clientName} - ${title}` })))

        this.setState({ unassignedTickets })
      })
  }

  render () {
    const {
      policy,
      tickets,
      addTicket,
      setTicket,
      associatedTicketSelections,
      removeAssociatedTicketSelection,
      removeTicket,
      currentUser,
      csi
    } = this.props

    const {
      unassignedTickets,
      ticketID,
      successMessage
    } = this.state

    const canAttachTickets = policy('problem', 'attachTickets')
    const canDeleteTickets = policy('problem', 'removeTickets')

    return (
      <React.Fragment>
        {isEmpty(tickets) && 'There are no attached tickets'}
        {successMessage && (
          <Alert
            close={() => this.setState({ successMessage: null })}
            type="success"
          >
            {successMessage}
          </Alert>
        )}

        <List>
          {map(tickets, (ticket, index) => (
            <ListItem>
              <div className="flex-1">
                <Link href={`/tickets/${ticket.id}`}>
                  <span className="flex-1 duration-300 text-blue-500 hover:text-blue-700 hover:underline">
                    {`${ticket.id} - ${ticket.title}`}
                  </span>
                </Link>
              </div>

              <button
                className="text-3xl text-blue-500 duration-300 hover:text-blue-700 mx-3"
                type="button"
                onClick={() => this.setState({ ticketID: ticket.id })}
                title="Incident Report"
              >
                <Icon type="document" />
              </button>

              {canDeleteTickets && (
                <button
                  className="text-3xl text-red-500 duration-300 hover:text-red-700 mr-3"
                  type="button"
                  onClick={() => { window.confirm('Are you sure you want to remove this ticket from this problem?') && removeTicket(index) }}
                >
                  <Icon type="trash2" />
                </button>

              )}
            </ListItem>
          ))}
        </List>

        <div className="mt-4" />

        { _.map(associatedTicketSelections, (ticketId, index) => {
          const last = index === associatedTicketSelections.length - 1
          const selectableTickets = _.omit(unassignedTickets, _.without(associatedTicketSelections, ticketId))

          return (
            <React.Fragment key={index}>
              <TicketSelector
                tickets={selectableTickets}
                onDelete={() => removeAssociatedTicketSelection(index)}
                value={ticketId}
                setValue={setTicketId => setTicket(index, setTicketId)}
                sortMethod={options => _.sortBy(options, option => 0 - Number(option.value))}
              />

              {last && canAttachTickets && (
                <button
                  className="flex items-center justify-center mt-2 text-blue-500 duration-300 hover:text-blue-600 font-semibold"
                  type="button"
                  onClick={() => addTicket()}
                >
                  <span className="text-4xl">+</span>
                  <span className="ml-2">Add another ticket</span>
                </button>
              )}
            </React.Fragment>
          )
        })}

        { _.isEmpty(associatedTicketSelections) && canAttachTickets && (
          <button
            className="flex items-center justify-center mt-2 text-blue-500 duration-300 hover:text-blue-600 font-semibold"
            type="button"
            onClick={() => addTicket()}
          >
            <span className="text-4xl">+</span>
            <span className="ml-2">Add a ticket</span>
          </button>
        )}

        <IncidentReport
          ticketID={ticketID}
          onClose={() => this.setState({ ticketID: null })}
          onSuccess={message => this.setState({ successMessage: message })}
          currentUser={currentUser}
          problemCSITasks={csi}
          policy={policy}
        />
      </React.Fragment>
    )
  }
}

AssociatedTicketContent.propTypes = {
  policy: PropTypes.func.isRequired,
  addTicket: PropTypes.func.isRequired,
  setTicket: PropTypes.func.isRequired,
  removeTicket: PropTypes.func.isRequired,
  removeAssociatedTicketSelection: PropTypes.func.isRequired,
  associatedTicketSelections: PropTypes.arrayOf(PropTypes.string),
  tickets: PropTypes.arrayOf(PropTypes.object),
  paths: PropTypes.shape({
    apiProblemsUnassignedTicketsPath: PropTypes.string
  }).isRequired
}

AssociatedTicketContent.defaultProps = {
  associatedTicketSelections: [],
  tickets: []
}

export default AssociatedTicketContent
